export const themeOne = {
    primary: "#01BF71",
    light: "#B2E7D2",
    lighter: "#01BF7110",
    dark: "#044348",
};

export const themeTwo = {
    primary: "#E6B800",
    light: "#E6B80020",
    lighter: "#E6B80010",
    dark: "#483D04",
};

export const themeThree = {
    primary: "#E44F4F",
    light: "#E44F4F20",
    lighter: "#E44F4F10",
    dark: "#482504",
};

export const themeColors = [themeOne, themeTwo, themeThree];
